import { useState, useRef } from "react";

import api from "@helpers/api";

import "./styles.css";

import CustomModal from "@components/CustomModal";

import {Input} from "@fragments";

export default function ConfigCouponsModal({ modalRef }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const REF_config = useRef({});
  const REF_callback = useRef();

  const [coupom, setCoupon] = useState({});

  modalRef.current = {
    open(preFill, callback) {
      REF_config.current = {
        ...(preFill)
      };

      REF_callback.current = callback;

      setCoupon({ ...REF_config.current });
      setOpen(true);
    },
  };

  async function handleSubmit() {
    try {
      setLoading(true);

      const payload = getPayload()

      const { data } = await api.post("coupon", payload);

      if (data.id) {
        await REF_callback.current(data);
        setOpen(false)
      }
    } catch (e) {
      setLoading(false);

      console.log(e);
    }

    setLoading(false);

    function getPayload() {
      const { id, code, percent_off, duration, duration_in_months } =
        REF_config.current;

      const data = {
        community: REF_config.current.community,
        currency: "brl",
        code: code
          .trim()
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-zA-Z0-9]/g, ""),
        percent_off: parseInt(percent_off),
        duration,
        duration_in_months:
          duration === "repeating" ? parseInt(duration_in_months) : undefined,
      };

      if (!!id) {
        data.id = parseInt(id);
      }

      return data;
    }
  }

  return (
    <CustomModal
      maxWidth={360}
      bottomButtonSumbitText="Salvar cupom"
      bottomButtonCancelText="Cancelar"
      handleSubmit={handleSubmit}
      loading={loading}
      title={"Gerenciar cupom"}
      open={open}
      handleClose={() => setOpen(false)}
      bodyComponent={
        open ? (
          <div className="px-4 py-1">
            <div className="mb-1 mt-2">
              <Input.Text
                autoFocus={true}
                value={coupom?.code || ''}
                onInput={(v) => {
                  REF_config.current.code = v;
                }}
                label="Código do cupom"
                className="coupon-code"
                style={{ width: '100%' }}
              />
              <Input.Integer
                disabled={!!coupom?.id}
                className="coupon-discount mt-2"
                value={coupom?.percent_off}
                onInput={(v) => {
                  REF_config.current.percent_off = v;
                }}
                min={1}
                max={100}
                label="% de desconto"
              />
            </div>
          </div>
        ) : null
      }
    />
  );
}
